<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="investorRefundId !== null" :confirm="true"
                    :title="$t('Modify') + ' ' + $t('l') + ' ' + $t('refund') + ' - ' + investorName" :params="{investorContratId:this.investorContratId}"
                    route-back="InvestorShow"/>
        <back-arrow v-else :confirm="askConfirm" :params="{investorContratId:this.investorContratId}"
                    :title="$t('New') + ' ' + $t('refund') + ' - ' + investorName" route-back="InvestorShow"/>
      </div>

      <b-card class="col-md-12 my-3">
        <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

          <div v-for="(refund, index) in form.refunds" :key="index" class="row">
            <div class="col-md-6">
              <b-form-group
                :invalid-feedback="refund.amount.invalidFeedback"
                :label="$t('refund.Amount')"
                :label-for="`refund-input-'${index}`"
                :state="refund.amount.state"
                class="medium-label mb-4">
                <b-form-input
                  :id="`refund-input-'${index}`"
                  v-model="refund.amount.value"
                  v-disable-scroll
                  :state="refund.amount.state"
                  required
                  type="number"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group
                :invalid-feedback="refund.dateRefund.invalidFeedback"
                :label="$t('refund.dateRefund')"
                :label-for="`date-refund-input-'${index}`"
                :state="refund.dateRefund.state"
                class="medium-label mb-4">
                <datepicker-input
                  :id="`date-refund-input-'${index}`"
                  v-model="refund.dateRefund.value"
                  required
                  v-on:change="askConfirm=true;">
                </datepicker-input>
              </b-form-group>
            </div>
          </div>

          <div v-if="investorRefundId !== null" class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
          </div>

          <div v-else class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Create') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import backArrow from "../../../components/b122/BackArrow";
import api from "../../../services/api";
import DatepickerInput from "../../../components/b122/editFields/DatepickerInput.vue";

export default {
  name: "InvestorRefundCreateEdit",

  components: {
    backArrow,
    DatepickerInput
  },

  data() {
    return {
      investorRefundId: this.$route.params.investorRefundId,
      investorContratId: this.$route.params.investorContratId,
      operationId: this.$route.params.operationId,
      investorName: this.$route.params.investorName,
      askConfirm: false,
      form: {
        refunds: []
      }
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      if (this.investorRefundId) {
        await this.fetchRefund()
      } else {
        this.addRefund()
      }
    },

    async fetchRefund() {
      await api
        .get(`/investorRefund/${this.investorRefundId}`)
        .then(response => {
          this.form.refunds.push({
            amount:
              {
                state: null,
                invalidFeedback: null,
                value: Number(response.data.amount / 100)
              },
            dateRefund:
              {
                state: null,
                invalidFeedback: null,
                value: (new Date(response.data.dateRefund).toLocaleDateString().split("/").reverse().join("-"))
              }
          })
        })
    },

    addRefund() {
      this.form.refunds.push({
        amount:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        dateRefund:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      })
    },

    async onSubmit() {
      await this.createOrUpdateInvestorRefund()
      await this.generateMonthlyCharges()
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          this.$router.push({
            name: 'InvestorShow',
            params: {
              message: error.response.data.message,
              investorContratId: this.investorContratId
            }
          })
        })
    },

    async createOrUpdateInvestorRefund() {
      for (const refund of this.form.refunds) {
        let data = new FormData()
        data.append('contrat', this.investorContratId)
        data.append('amount', refund.amount.value)
        data.append('dateRefund', refund.dateRefund.value)

        let url = 'investorRefund'
        if (this.investorRefundId) {
          url = '/investorRefund/' + this.investorRefundId
        }

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then((response) => {
            this.investorContratId = response.data.contrat.id
            this.$router.push({
              name: 'InvestorShow',
              params: {
                investorContratId: this.investorContratId
              }
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'InvestorShow',
                params: {
                  message: error.response.data.message,
                  investorContratId: this.investorContratId
                }
              })
            } else if (error.response.status === 403) {
              const invalidField = error.response.data.invalidField
              refund[invalidField]['state'] = false
              refund[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
            }
          })
      }
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('Refund') + ' ' + this.$i18n.t('registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/investor/investorRefund/InvestorRefundCreateEdit.vue